import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props}><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" /><path d="M0 0h24v24H0z" fill="none" /></svg>);